<template>
  <div class="layout default-layout">
    <AppHeader/>
    <router-view/>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'DefaultLayout',
  components: {
    AppHeader,
  },
};
</script>
